// extracted by mini-css-extract-plugin
export var twoColumn = "formTwoColumn-module--twoColumn--1f9c9";